/**
 * @param {string} phone +7 (000) 000 00-00 etc.
 * @returns {string} +70000000000
 */
export function getPhoneNumber(phone: string): string {
  return '+' + phone.match(/\d+/g).join('')
}

export function formatPhone(p: string): string {
  if (p[0] === '+') {
    return `+7 (${p.slice(2, 5)})  ${p.slice(5, 8)}-${p.slice(8, 10)}-${p.slice(
      10,
      12
    )}`
  }

  return `8 (${p.slice(1, 4)})  ${p.slice(4, 7)}-${p.slice(7, 9)}-${p.slice(
    9,
    11
  )}`
}

export function getNumberFromString(string: string): string {
  return (string.match(/\d+/g) ?? []).join('')
}

export function formatNumber(number: number): string {
  return new Intl.NumberFormat('ru-RU').format(number)
}

/**
 * Форматирует секунды в человекочитаемую строку:
 * 45 → «45 сек», 125 → «2 мин 5 сек», 13773 → «3 ч 49 мин»
 */
export function formatTimerValue(seconds: number): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  if (hours > 0) {
    return minutes > 0 ? `${hours} ч ${minutes} мин` : `${hours} ч`
  }

  if (minutes > 0) {
    return secs > 0 ? `${minutes} мин ${secs} сек` : `${minutes} мин`
  }

  return `${secs} сек`
}
